import React, { Component, PureComponent, Fragment } from 'react';
import { css, theme } from 'constants';
import { View, TextInput } from 'core';
import { search } from 'utils';
import { lang } from 'lang';

const styles = css({
  holder: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    paddingHorizontal: 10,
    backgroundColor: theme.gray_color_lighten(0.01),
    borderColor: theme.gray_color_lighten(0.1),
    borderBottomWidth: theme.hairline
  },
  search: {
    width: '100%',
    height: 30,
    borderRadius: 15,
    backgroundColor: theme.gray_color_lighten(0.1),
    fontSize: theme.xs,
    borderWidth: 0
  }
});

export const SearchBox = ({ source, onChange, keys, style, content_style }) => (
  <View style={[styles.holder, style]}>
    <TextInput
      style={[styles.search, content_style]}
      placeholder={lang.SEARCH}
      autoFocus
      onChangeText={val => {
        onChange(search(source, keys, val.trim(), 50));
      }}
    />
  </View>
);



// WEBPACK FOOTER //
// ./src/components/core/search_box.js